import Attivita from './Attivita';
import {minutesToHuman} from '../Helpers'

class AttivitaPerCommessa extends Attivita {

    createPdf(items){

        const columns = [
            {title: "Id", dataKey: "id"},
            {title: "Colore", dataKey: "colore"},
            {title: "Commessa", dataKey: "com"},
            {title: "Utente", dataKey: "ute"},
            {title: "Num sessioni", dataKey: "ses"},
            //{title: "Durata Totale\n(minuti)", dataKey: "duratamin"},
            {title: "Durata Totale\n(h:m:s)", dataKey: "duratahms"},
        ];
        let rows = [];
        let numAttivitaTot = 0;
        let durataPesataTot = 0;

        items.map((item) => {
            let it = {
                id: item.commessa.idCommessa,
                colore: item.commessa.colore,
                com: item.commessa.nomeCompleto,
                ute: item.utente.username,
                ses: item.numAttivita,
                duratamin: item.durataPesata,
                duratahms: minutesToHuman(item.durataPesata),
            };
            rows.push(it);
            numAttivitaTot += item.numAttivita;
            durataPesataTot += item.durataPesata;
            return 0;
        });
        rows.push({
            id: '',
            colore: '',
            com: '',
            ute: '',
            ses: numAttivitaTot,
            //duratamin: durataPesataTot,
            duratahms: minutesToHuman(durataPesataTot),
        })

        super.createPdf(columns, rows,
            {
                createdCell: this.doDrawCell,
                drawRow: this.doDrawRow,
                columnStyles: {
                    com: {halign: 'left', columnWidth: 'auto', overflow:'hidden'},
                    ses: {halign: 'center'},
                    duratamin: {halign: 'center'},
                    duratahms: {halign: 'center'},
                },
                headerStyles: {
                    valign: 'middle',
                    halign: 'center',
                    //fillColor: [0x56, 0x9e, 0xdd],
                    //fillColor: [0xFF, 0xFF, 0xFF],
                    fillColor: false,
                    textColor: [0,0,0],
                    ses:{halign: 'center'},
                    duratamin:{halign: 'center'},
                    duratahms:{halign: 'center'},
                },
            });
    }


}

export default AttivitaPerCommessa;


/** WEBPACK FOOTER **
 ** ./src/pdf/AttivitaPerCommessa.js
 **/